import {connect} from 'react-redux';

import {getTimeFormat} from '../../../src/store/data/preferences/preferencesSelectors';
import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {AbsoluteDateTimeFormatter} from './absoluteDateTimeFormatter';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  timeFormat: getTimeFormat,
}));

export const AbsoluteDateTimeFormatterContainer = connect(mapStateToProps)(AbsoluteDateTimeFormatter);
